
<c-audit-overview
    v-if         = "data"
    :data        = "data"
    :height      = "height-420"
    :type        = "type"
    :device-type = "deviceType"
    :country     = "inspection.country"
/>
